var _rect, _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 21,
    rx: 10.5,
    stroke: "#D2D5D6"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6404_194)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6404_194",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z",
    fill: "#F8F8F8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6404_194)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 7,
    width: 20,
    height: 8,
    fill: "#ABC560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1H21V7.5H1V1Z",
    fill: "#F1D07C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 14.5H21V21H1V14.5Z",
    fill: "#CE5872"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6404_194"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(1 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLt);
export default __webpack_public_path__ + "static/media/lt.c96344060e862c7f15bf0bf64eeee6a1.svg";
export { ForwardRef as ReactComponent };